import { DashboardCustomize, DashboardSharp } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import DashboardCard from '../../../Components/DashboardCard/DashboardCard'
import { use } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice'
import BellCurveChart from './BellCurve'
import { Box, Button, Container, Grid } from '@mui/material'
// import PerformanceReport from './PerformanceReport'
import LatestEvaluations from './LatestEvaluations'
import actions from '../../../ReduxStore/actions'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PeopleIcon from '@mui/icons-material/People';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { FaCheckCircle } from 'react-icons/fa'
import { FaUsers } from 'react-icons/fa6'
import { HiUserGroup } from 'react-icons/hi2'
import { Formik, Form } from 'formik'
import CustomDropdownMui from '../../../Components/CustomDropDown/CustomDropdown'
import { setInitialStateOfgetEmployeeDashboardByYear } from '../../../ReduxStore/Slices/Dashboard/getEmployeeDashboardByYear'


const Dashboard = () => {
    const dispatch = useDispatch()

    console.log("iitswork")
    // useEffect(() => {
    //     dispatch(setHeaderName("Dashboard"));
    //     dispatch(setSubHeaderName(""));
    // }, [dispatch]);

    const { getAllAppraisalYears } = useSelector((state) => state?.getAllAppraisalYears);
    const [dashboardData, setDashboardData] = useState(null);

    useEffect(() => {
        dispatch(setHeaderName("Dashboard"));
        dispatch(setSubHeaderName(""));
    }, [dispatch]);

    useEffect(() => {
        const fetchAppraisalYears = async () => {
            const data = {
                data: {},
                method: "get",
                apiName: "getAllAppraisalYears",
            };
            await dispatch(actions.GETALLAPPRAISALYEAR(data));
        };
        fetchAppraisalYears();
    }, [dispatch]);

    useEffect(() => {
        const fetchDashboardData = async () => {
            const data = {
                data: {},
                method: "get",
                apiName: "getEmployeeDashboard",
            };
            const response = await dispatch(actions.GETEMPLOYEEDASHBOARD(data));
            setDashboardData(response?.payload?.data || null);
        };
        fetchDashboardData();
    }, [dispatch]);

    const handleGetDataYearById = async (yearId) => {
        const data = {
            data: { appraisal_year_id: yearId },
            method: "post",
            apiName: "getEmployeeDashboardByYear",
        };
        const response = await dispatch(actions.GETEMPLOYEEDASHBOARDBYYEAR(data));
        setDashboardData(response?.payload?.data || null);
    };

    const yearOptions = getAllAppraisalYears?.data?.map((item) => ({
        value: item?.appraisal_year_id,
        label: item?.appraisal_year,
    })) || [];

    const { getEmployeeDashboard } = useSelector((state) => state?.getEmployeeDashboard);
    const employeeId = localStorage.getItem("employeeId")



    // useEffect(() => {
    //     const fetchData = async () => {

    //         const data1 = {
    //             data: {},
    //             method: "get",
    //             apiName: `getEmployeeDashboard`
    //         };
    //         const responseData = dispatch(actions.GETEMPLOYEEDASHBOARD(data1));
    //         console.log(responseData, "responseData")


    //     }
    //     fetchData()

    // }, [])
    // const stats = [
    //     {
    //         icon: <AttachMoneyIcon sx={{ color: '#fff' }} />,
    //         iconColor: '#212121',
    //         title: 'Total Employee',
    //         value: dashboardData?..total_employee_count,
    //     },
    //     {
    //         icon: <PeopleIcon sx={{ color: '#fff' }} />,
    //         iconColor: '#e91e63',
    //         title: 'Employee Evaluation Pending',
    //         value: dashboardData?..employee_appraisal_pending,
    //     },
    //     {
    //         icon: <GroupAddIcon sx={{ color: '#fff' }} />,
    //         iconColor: '#4caf50',
    //         title: 'Manager Evaluation Pending',
    //         value: dashboardData?..manager_employee_appraisal_pending,
    //     },
    //     {
    //         icon: <ShoppingCartIcon sx={{ color: '#fff' }} />,
    //         iconColor: '#2196f3',
    //         title: 'Reviewer Evaluation Pending',
    //         value: dashboardData?..reviewer_employee_appraisal_pending,
    //     },
    //     {
    //         icon: <ShoppingCartIcon sx={{ color: '#fff' }} />,
    //         iconColor: '#2196f3',
    //         title: 'PMS Closed',
    //         value: dashboardData?..total_appraisal_closed,
    //     },
    // ];
    const stats = [
        {
            icon: <FaUsers style={{ color: 'white', fontSize: "25px" }} />,
            iconColor: '#212121',
            title: 'Total Employee',
            total: dashboardData?.total_employee_count,
        },
        {
            icon: <PeopleIcon sx={{ color: '#fff' }} />,
            iconColor: '#e91e63',
            title: 'Employee Evaluation',
            total: dashboardData?.employee_appraisal_total,
            pending: dashboardData?.employee_appraisal_pending,
            completed: dashboardData?.employee_appraisal_completed,

        },
        {
            icon: <GroupAddIcon sx={{ color: '#fff' }} />,
            iconColor: '#4caf50',
            title: 'Manager Evaluation',
            total: dashboardData?.manager_employee_appraisal_total,
            pending: dashboardData?.manager_employee_appraisal_pending,
            completed: dashboardData?.manager_employee_appraisal_completed,


        },
        {
            icon: <HiUserGroup style={{ color: '#fff', fontSize: "25px" }} />,
            iconColor: '#2196f3',
            title: 'Reviewer Evaluation',
            total: dashboardData?.reviewer_employee_appraisal_total,
            pending: dashboardData?.reviewer_employee_appraisal_pending,
            completed: dashboardData?.reviewer_employee_appraisal_completed,

        },
        {
            icon: <FaCheckCircle style={{ color: 'white', fontSize: "25px" }} />,
            iconColor: '#2196f3',
            title: 'PMS Closed',
            total: dashboardData?.total_appraisal_closed,
        },
    ];
    const handleClearFilter = async (resetForm) => {
        resetForm()
        dispatch(setInitialStateOfgetEmployeeDashboardByYear())
        const data = {
            data: {},
            method: "get",
            apiName: "getEmployeeDashboard",
        };
        const response = await dispatch(actions.GETEMPLOYEEDASHBOARD(data));
        setDashboardData(response?.payload?.data || null);

    }



    return (
        <Grid container spacing={2}>
            <Grid item size={{ xs: 12 }}>
                <Formik
                    initialValues={{ filterByYear: "" }}
                    onSubmit={(values) => {
                        handleGetDataYearById(values.filterByYear);
                    }}
                >
                    {({ values, setFieldValue, resetForm }) => (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid item size={{ xs: 12, sm: 6 }}>
                                    <CustomDropdownMui
                                        name="filterByYear"
                                        label="Filter by Year"
                                        custPlaceholder="--Select--"
                                        options={yearOptions}
                                        isDashboard={true}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, sm: 6 }} sx={{ display: "flex", justifyContent: "start", alignItems: "end" }}>
                                    <Box sx={{ mt: { xs: 1, sm: 0 }, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        {values?.filterByYear && (
                                            <Button
                                                type="submit"
                                                variant='contained'
                                                onClick={() => {
                                                    handleClearFilter(resetForm)
                                                }}

                                                sx={{
                                                    background: "#e3e2e2",
                                                    textTransform: "none",
                                                    color: "black",
                                                    mr: 2,
                                                    boxShadow: "none"
                                                }}
                                            >
                                                Clear Filter

                                            </Button>
                                        )}
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            disabled={!values?.filterByYear}
                                            sx={{
                                                textTransform: "none",
                                                color: "white",
                                                fontSize: "16px",
                                                padding: { xs: "0px 20px", md: "0px 20px" },
                                                boxShadow: "none",
                                                minHeight: "40px",
                                                background: "var(--main-color)",
                                                "&:hover": {
                                                    backgroundColor: "var(--main-color)",
                                                },
                                            }}
                                        >
                                            Apply Filter
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Grid>

            <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
                <DashboardCard stats={stats} />
            </Grid>
            {/* <Container>
                <BellCurveChart />
            </Container> */}
            {/* <Grid size={{ xs: 12 }}>

                <Box sx={{ mt: 2 }}>
                    <PerformanceReport />
                </Box>
            </Grid> */}
            {/* <Grid size={{ xs: 12 }}>

                <Box sx={{ mt: 2 }}>
                    <LatestEvaluations />
                </Box>
            </Grid> */}

        </Grid>
    )
}

export default Dashboard